// removed by extract-text-webpack-plugin
module.exports = {"Card":"ddfO1NePJzDyMRSLhhs5w","EmptyChart":"_1MAXOhk2wdy5J2mOd2zcGb"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Charts/styles.module.css
// module id = 527
// module chunks = 0